var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import rpc from 'src/api/rpc';
import { setCurrentColorTheme } from 'src/platform/userPreferences/utils';
import { getActingUser } from 'src/utils/actingUser';
import addRecordsToLocalState from 'src/utils/entityOperations/addRecordsToLocalState';
import getFullTable from 'src/utils/entityOperations/getFullTable';
import updateRecordsInLocalState from 'src/utils/entityOperations/updateRecordsInLocalState';
const entity = 'preferences.option_user_values';
export default function setOptionValue(option_id, value) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (option_id === 2) {
            setCurrentColorTheme(Number(value));
            return { result: 'success' };
        }
        const user_id = getActingUser().id;
        const payload = {
            action: 'insert',
            records: [{ option_id, user_id, value }],
            api_version: 1,
            entity,
            do_not_log_on_backend: true,
            on_conflict: {
                conflict_target: ['option_id', 'user_id'],
                update_columns: ['value']
            }
        };
        // Speculatively update local state before API call
        const currentRecords = getFullTable(entity);
        const existingRecord = currentRecords === null || currentRecords === void 0 ? void 0 : currentRecords.find(r => Number(r.option_id) === Number(option_id) && Number(r.user_id) === Number(user_id));
        if (existingRecord) {
            updateRecordsInLocalState(entity, [Object.assign(Object.assign({}, existingRecord), { value })]);
        }
        const response = yield rpc('generic_controllers.rpc', payload);
        if (!response || response.result === 'error') {
            // Revert local state if API call fails
            if (existingRecord) {
                updateRecordsInLocalState(entity, [existingRecord]);
            }
            return response;
        }
        else if (response.result === 'success') {
            // Update local state with server response
            const serverRecord = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a[0];
            if (serverRecord) {
                if (existingRecord) {
                    updateRecordsInLocalState(entity, [Object.assign(Object.assign({}, existingRecord), serverRecord)]);
                }
                else {
                    addRecordsToLocalState(entity, [serverRecord]);
                }
            }
        }
        return response;
    });
}
